<div class="eon-dropdown-menu" [class.-active]="showDropdown">
  <div class="dropdown-value" (click)="toggleDropdown()">
    <span class="fa fa-map-marker fa-lg"></span>
    <input class="select" [placeholder]="dropdownFieldConfig.municipalityFieldPlaceholder" [value]="selectedMunicipality" (focus)="toggleDropdown()" />
    <div><span matPrefix class="fa fa-chevron-down chevron fa-lg"></span></div>
  </div>

  <div class="dropdown-hover" *ngIf="showDropdown">
    <div class="dropdown-value" (click)="toggleDropdown()">
      <span class="fa fa-map-marker fa-lg"></span>
      <input class="select" [placeholder]="dropdownFieldConfig.municipalityFieldPlaceholder" [value]="selectedMunicipality" (focus)="toggleDropdown()" />
      <div><span matPrefix class="fa fa-chevron-down chevron fa-lg"></span></div>
    </div>

    <div class="dropdown-content">
      <hr class="divider" />
      <app-municipality-selection
        class="municipality-section"
        [displaySearch]="displaySearch"
        [selectedToggleOption]="selectedToggleOption"
        [selectedMunicipality]="selectedMunicipality"
        [municipalities]="municipalities"
        [searchableByKey]="true"
        [showCheckBox]="showCheckBox"
        [searchFieldConfig]="dropdownFieldConfig"
        (displayMunicipalities)="selectedMunicipalities($event)"
        (municipalityChangeEvent)="selectMunicipality($event)"
        (municipalitiesChangeEvent)="selectMunicipality($event)"
      ></app-municipality-selection>
    </div>
  </div>
</div>
